"use client"

import { useEffect, useState } from "react"

interface OpsiKesiapanHalaman {
  tampilMinimalMs?: number
  tungguMaksimalMs?: number
}

function tungguDokumen(): Promise<void> {
  if (document.readyState === "complete") return Promise.resolve()
  return new Promise((selesai) => window.addEventListener("load", () => selesai(), { once: true }))
}

function tungguFont(): Promise<void> {
  if (!document.fonts) return Promise.resolve()
  return document.fonts.ready.then(() => undefined)
}

function tungguSisaTampilMinimal(tampilMinimalMs: number): Promise<void> {
  const sisa = Math.max(0, tampilMinimalMs - performance.now())
  return new Promise((selesai) => setTimeout(selesai, sisa))
}

export function useKesiapanHalaman({ tampilMinimalMs = 1200, tungguMaksimalMs = 5000 }: OpsiKesiapanHalaman = {}) {
  const [siap, setSiap] = useState(false)

  useEffect(() => {
    let dibatalkan = false
    const tandaiSiap = () => {
      if (!dibatalkan) setSiap(true)
    }

    Promise.all([tungguDokumen(), tungguFont(), tungguSisaTampilMinimal(tampilMinimalMs)]).then(tandaiSiap)
    const pengaman = setTimeout(tandaiSiap, tungguMaksimalMs)

    return () => {
      dibatalkan = true
      clearTimeout(pengaman)
    }
  }, [tampilMinimalMs, tungguMaksimalMs])

  return siap
}
